import type { ReactNode } from 'react';

export function chartNum(value: unknown): number {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
}

export function chartLabel(label: ReactNode): string {
  return typeof label === 'string' || typeof label === 'number' ? String(label) : '';
}
